// Error404.jsx
import React from "react";
import "./Error404.css";
import errorGif from "../images/Error.gif"; // Ensure this is in the public or assets folder
import { useNavigate } from "react-router-dom";

const Error404 = () => {
  const navigate = useNavigate();
  
  return (
    <div className="error-page-container">
      <img src={errorGif} alt="Hungry Stomach" className="error-page-gif" />
      <h1>Looks like your hunger led you to the wrong place!</h1>
      <p>Let’s feed you right! Check out our delicious menu!</p>
      <button className="error-page-menu-button" onClick={() => navigate("/Menu")}>Go to Menu</button>
    </div>
  );
};

export default Error404;
